import {
  WidgetInstance,
} from 'mobx-store/stores/customScreens/types';
import { ValidationOptionsKeys } from 'screens/addEditCustomScreen/types';
import { ValidationSchema } from '../validation.helper';

export interface Props {
  focusedWidgetData: WidgetInstance;
  focusedWidget: null | string | number;
  handleChangeData: (paramName: string, value: any) => void;
  handleMultipleChangeData: (params: {}) => void;
  removeFocusedWidget: () => void;
}


export const tabWidgetValidation: ValidationSchema =  {
  subTitle: [
    {
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'showTextImage',
        value: false
      }
    }
  ],
  textImage: [
    {
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'showTextImage',
        value: true
      }
    }
  ],
  isImageArrow: [],
  imageURL: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  redirect: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  entityId: []


}